import { render, staticRenderFns } from "./PaymentManagement.vue?vue&type=template&id=65c3af9a"
import script from "./PaymentManagement.vue?vue&type=script&lang=js"
export * from "./PaymentManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports